/* generated using codegen.ts -- do not edit */
/* tslint:disable */
/* eslint-disable */
import { Inject, NgModule, Optional, SkipSelf } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AccessGroupService } from './services/AccessGroupService';
import { AccessRequestControllerv2Service } from './services/AccessRequestControllerv2Service';
import { AccessRequestLogsControllerv2Service } from './services/AccessRequestLogsControllerv2Service';
import { AccessRequestService } from './services/AccessRequestService';
import { ActionService } from './services/ActionService';
import { AnnouncementControllerv2Service } from './services/AnnouncementControllerv2Service';
import { CaregiverService } from './services/CaregiverService';
import { ClinTrakStudyService } from './services/ClinTrakStudyService';
import { ClinTrakStudySiteService } from './services/ClinTrakStudySiteService';
import { CountryService } from './services/CountryService';
import { CurrencyExchangeRateControllerV2Service } from './services/CurrencyExchangeRateControllerV2Service';
import { CurrencyService } from './services/CurrencyService';
import { DictionaryService } from './services/DictionaryService';
import { EntityHierarchyControllerv2Service } from './services/EntityHierarchyControllerv2Service';
import { ErrorReportControllerv2Service } from './services/ErrorReportControllerv2Service';
import { ExpenseService } from './services/ExpenseService';
import { ExpenseTrackingService } from './services/ExpenseTrackingService';
import { GetThereService } from './services/GetThereService';
import { HistoryDataService } from './services/HistoryDataService';
import { KycAuditLogService } from './services/KycAuditLogService';
import { MileageReimbursementRateControllerv2Service } from './services/MileageReimbursementRateControllerv2Service';
import { MileageReimbursementRateService } from './services/MileageReimbursementRateService';
import { OtherClinTrakDataService } from './services/OtherClinTrakDataService';
import { PatientClinTrakDataService } from './services/PatientClinTrakDataService';
import { PatientControllerv2Service } from './services/PatientControllerv2Service';
import { PatientEditRequestService } from './services/PatientEditRequestService';
import { PatientPortalAccessRequestControllerV2Service } from './services/PatientPortalAccessRequestControllerV2Service';
import { PatientPortalAccessRequestService } from './services/PatientPortalAccessRequestService';
import { PatientService } from './services/PatientService';
import { PaymentApprovalsControllerv2Service } from './services/PaymentApprovalsControllerv2Service';
import { PaymentProviderInvitationApprovalRequestControllerv2Service } from './services/PaymentProviderInvitationApprovalRequestControllerv2Service';
import { PcsConfigurationControllerv2Service } from './services/PcsConfigurationControllerv2Service';
import { RegionService } from './services/RegionService';
import { ReimbursementRequestControllerV2Service } from './services/ReimbursementRequestControllerV2Service';
import { ReportService } from './services/ReportService';
import { RequestControllerv2Service } from './services/RequestControllerv2Service';
import { RequestService } from './services/RequestService';
import { RequestStatusLogService } from './services/RequestStatusLogService';
import { SiteClinTrakDataService } from './services/SiteClinTrakDataService';
import { SiteControllerv2Service } from './services/SiteControllerv2Service';
import { SiteService } from './services/SiteService';
import { StipendRequestControllerV2Service } from './services/StipendRequestControllerV2Service';
import { StudyClinTrakDataService } from './services/StudyClinTrakDataService';
import { StudyControllerV2Service } from './services/StudyControllerV2Service';
import { StudyPaymentApprovalThresholdControllerV2Service } from './services/StudyPaymentApprovalThresholdControllerV2Service';
import { StudyService } from './services/StudyService';
import { TravelOptionService } from './services/TravelOptionService';
import { TravelRequestControllerV2Service } from './services/TravelRequestControllerV2Service';
import { UserControllerV2Service } from './services/UserControllerV2Service';
import { UserService } from './services/UserService';
import { API_BASE_URL } from '@app/API_BASE_URL';
import { OpenAPI } from './core/OpenAPI';       

@NgModule({
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
        AccessGroupService,
        AccessRequestControllerv2Service,
        AccessRequestLogsControllerv2Service,
        AccessRequestService,
        ActionService,
        AnnouncementControllerv2Service,
        CaregiverService,
        ClinTrakStudyService,
        ClinTrakStudySiteService,
        CountryService,
        CurrencyExchangeRateControllerV2Service,
        CurrencyService,
        DictionaryService,
        EntityHierarchyControllerv2Service,
        ErrorReportControllerv2Service,
        ExpenseService,
        ExpenseTrackingService,
        GetThereService,
        HistoryDataService,
        KycAuditLogService,
        MileageReimbursementRateControllerv2Service,
        MileageReimbursementRateService,
        OtherClinTrakDataService,
        PatientClinTrakDataService,
        PatientControllerv2Service,
        PatientEditRequestService,
        PatientPortalAccessRequestControllerV2Service,
        PatientPortalAccessRequestService,
        PatientService,
        PaymentApprovalsControllerv2Service,
        PaymentProviderInvitationApprovalRequestControllerv2Service,
        PcsConfigurationControllerv2Service,
        RegionService,
        ReimbursementRequestControllerV2Service,
        ReportService,
        RequestControllerv2Service,
        RequestService,
        RequestStatusLogService,
        SiteClinTrakDataService,
        SiteControllerv2Service,
        SiteService,
        StipendRequestControllerV2Service,
        StudyClinTrakDataService,
        StudyControllerV2Service,
        StudyPaymentApprovalThresholdControllerV2Service,
        StudyService,
        TravelOptionService,
        TravelRequestControllerV2Service,
        UserControllerV2Service,
        UserService,
    ],
})
export class ApiModule {
    constructor(
        @Optional() @SkipSelf() _parentModule: ApiModule,
        @Optional() @Inject(API_BASE_URL) basePath: string
    ) {
        if (basePath) {        
            OpenAPI.BASE = basePath;
        }
    }
}
